import { defineComponent as _defineComponent } from 'vue'
import ChannelsNotificationHub from './ChannelsNotificationHub.vue'
import JobUpdates from './JobUpdates.vue'
import NotificationSettings from './Settings.vue'
import UnreadCount from './UnreadCount.vue'
import NavItem from '../nav/NavItem.vue'
import { useChatStore } from '@/components/common/chat/useChatData'
import { computed, ref } from 'vue'
import { useGetters } from 'vuex-composition-helpers'

type TabType = 'tab-messages' | 'tab-jobUpdates' | 'tab-settings'

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsPanel',
  setup(__props) {

const tabs = ref<TabType>('tab-messages')

const store = useChatStore()

const { hasChatAccess, hasNotificationAccess } = useGetters('permissions', [
  'hasChatAccess',
  'hasNotificationAccess',
])

const label = computed(() => {
  return hasChatAccess.value ? 'Messages & Alerts' : 'Alerts'
})

const totalUnreadCount = computed(() => {
  const count = hasChatAccess.value ? visibleChatUnreadCount.value : 0
  return count > 99 ? '99+' : count
})

const tabItems = computed(() => {
  const items: any[] = []

  if (hasChatAccess.value) {
    items.push({ href: '#tab-messages', name: 'Messages' })
  }

  if (hasNotificationAccess.value) {
    items.push({ href: '#tab-jobUpdates', name: 'Job Updates' })
  }

  return items
})

const visibleChatUnreadCount = computed(() => {
  return store.filteredChannels
    .map((channel) => channel.unreadCount || 0)
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
})

const showUnreadCountForTab = (name: string) => {
  return name === 'Messages' && visibleChatUnreadCount.value > 0
}

return { __sfc: true,tabs, store, hasChatAccess, hasNotificationAccess, label, totalUnreadCount, tabItems, visibleChatUnreadCount, showUnreadCountForTab, ChannelsNotificationHub, JobUpdates, NotificationSettings, UnreadCount, NavItem }
}

})